const AmazonQLogo = ({ width = "24px", height = "24px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 106.14 115.53"
      width={width}
      height={height}
    >
      <title>Amazon Q</title>
      <defs>
        <linearGradient
          id="grad-1"
          x1="-228.54"
          y1="480.48"
          x2="-246.11"
          y2="446.65"
          gradientTransform="translate(569.95 1056) scale(2.16 -2.16)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#2fabff" />
          <stop offset=".31" stop-color="#5570ff" />
          <stop offset=".62" stop-color="#7b36ff" />
          <stop offset=".81" stop-color="#6a2cdc" />
          <stop offset="1" stop-color="#5921b8" />
        </linearGradient>
      </defs>
      <g style={{ isolation: "isolate", opacity: ".26;" }}>
        <path
          d="M57.82,2.58c-2.78-1.49-7.28-1.48-10.05.02L6.48,25.03c-2.77,1.5-5.02,5.29-5.02,8.44v46.67c0,3.15,2.21,7,4.94,8.59l41.45,24.15c2.72,1.59,7.16,1.61,9.9.05l41.96-23.9c2.74-1.56,4.96-5.39,4.96-8.54v-47c0-3.15-2.25-6.92-5.03-8.42L57.82,2.58Z"
          style={{ fill: "none", stroke: "#fff", "stroke-width": "2.93px" }}
        />
      </g>
      <path
        d="M60.78,7.84c-4.36-2.52-9.73-2.52-14.08,0L14.44,26.47c-4.36,2.52-7.04,7.17-7.04,12.2v37.26c0,5.03,2.68,9.68,7.04,12.2l32.26,18.63c4.36,2.52,9.73,2.52,14.08,0l32.26-18.63c4.36-2.52,7.04-7.17,7.04-12.2v-37.26c0-5.03-2.68-9.68-7.04-12.2L60.78,7.84Z"
        style={{ fill: "url(#grad-1)" }}
      />
      <path
        d="M48.26,21.44l-22.88,13.21c-3.49,2.01-5.63,5.73-5.63,9.76v26.43c0,4.03,2.15,7.74,5.63,9.76l22.88,13.21c3.49,2.01,7.78,2.01,11.27,0l22.88-13.21c3.49-2.01,5.63-5.73,5.63-9.76v-26.43c0-4.03-2.15-7.74-5.63-9.76l-22.88-13.21c-3.49-2.01-7.78-2.01-11.27,0ZM51.78,27.7c1.74-1.01,3.89-1.01,5.63,0l21.81,12.59c1.74,1.01,2.82,2.86,2.82,4.88v25.19c0,2.01-1.07,3.87-2.82,4.88l-21.81,12.59c-1.74,1.01-3.89,1.01-5.63,0l-21.81-12.59c-1.74-1.01-2.82-2.86-2.82-4.88v-25.19c0-2.01,1.07-3.87,2.82-4.88l21.81-12.59ZM54.25,51.32c-.44-.25-.97-.25-1.41,0l-4.69,2.71c-.44.25-.7.72-.7,1.22v5.42c0,.5.27.97.7,1.22l4.69,2.71c.44.25.97.25,1.41,0l4.69-2.71c.44-.25.7-.72.7-1.22v-5.42c0-.5-.27-.97-.7-1.22l-4.69-2.71ZM57.77,56.55l-2.82,5.63,26.76,15.49,2.82-5.63-26.76-15.49Z"
        style={{ fill: "#fff" }}
      />
    </svg>
  );
};

export default AmazonQLogo;
